import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/mp-health-squarespace-shopify-migration-case-study")({
  beforeLoad: () => {
    throw redirect({ to: "/resources/mp-health-squarespace-migration-case-study", statusCode: 301 });
  },
});
